import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Button, Row, Col, Modal, Card, CardBody, Form, Label, Input, FormGroup, FormFeedback } from "reactstrap";
import check from "./../../../assets/images/svg/check.svg";
import container from "../../../assets/images/svg/container.svg";
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';

const TrackStatus = ({ data, containerId, setcontainerNumber, trackData, containerNumber, trackId }) => {
    const [btnActive, setbtnActive] = useState([])
    const history = useHistory()
    const loading = useSelector(state => ({
        bookingByNo: state.GetByBookingNo
    }))
    useEffect(() => {
        let myarray = []
        if (containerId && data) {
            data[0]?.containerDetails?.map((item, index) => {
                if (containerId === item.containerNo) {
                    myarray[index] = true
                    setcontainerNumber(item.containerNo)
                }
                else myarray[index] = false
            })
        } else if (!containerId && data) {
            data[0]?.containerDetails?.map((item, index) => {
                if (index === 0) {
                    myarray[index] = true
                    setcontainerNumber(item.containerNo)
                }
                else myarray[index] = false
            })
        }
        setbtnActive(myarray)
    }, [containerId, data])
    const [status, setStatus] = useState(null)
    useEffect(() => {
        if (trackData?.track !== undefined && trackData?.track.length > 0) {
            if (trackData?.track[0]?.status === 'COMPLETED') {
                setStatus('complete')
            } else {
                setStatus('active')
            }
        } else {
            setStatus('')
        }
    }, [trackData])  
    return (
        <>

            <Row className='tracking-status-row'>
                <Col md="8">
                    <Row className='d-flex'>
                        <Col md="3">
                            <Card className='tract-info container-info mb-0'>
                                <CardBody >
                                    <div className='icon'>
                                        <img src={container} alt={'container'} />
                                    </div>
                                    <div className='info-card'>
                                        <p className='m-0'>Container number</p>
                                        <h6>{containerNumber || <Skeleton height={"20px"} width={'120px'} />}</h6>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md="9">
                            <Card className='tracking-status'>
                                <CardBody>
                                    <h5>Tracking Status</h5>
                                    {loading.bookingByNo.loading ? <div className='d-flex justify-content-center'>
                                        <Skeleton height={"100px"} width={'100%'} />
                                    </div> :
                                        <Row className='h-100'>
                                            <div className='progress-step'>
                                                <div className={`step active`}>
                                                <div className='content'>
                                                    <span className={""}>
                                                        <img src={check} alt={"check"} />

                                                    </span>
                                                    <div>
                                                        <p className='title'>Booked</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`step ${status}`}>

                                                <div className='content'>
                                                    <span className={""}>
                                                        <img src={check} alt={"check"} />

                                                    </span>
                                                    <div>
                                                        <p className='title'>In-Transit</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`step ${status === 'complete' ? status : ''}`}>

                                                <div className='content'>
                                                    <span className={""}>
                                                        <img src={check} alt={"check"} />

                                                    </span>
                                                    <div>
                                                        <p className='title'>Delivered</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div></Row>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Col md="4">
                    <Card className='container-number'>
                        <CardBody>
                            <div className='filed header'>
                                <h2>Other Container number</h2>
                                <h2>Action</h2>
                            </div>  
                            <div className='cardbody'>
                                {!data ? <>
                                    {[...Array(5)].map((item, index) => {
                                        return <div className='d-flex justify-content-sm-between' key={item}>
                                            <Skeleton height={"25px"} width={'120px'} />
                                            <Skeleton height={"25px"} width={'60px'} />
                                        </div>
                                    })}</> : <>
                                    {
                                        data && data[0]?.containerDetails?.map((item, index) => {
                                            return <div className='filed' key={index}>
                                                <p className='m-0'>{item?.containerNo}</p>
                                                <Button
                                                    className={btnActive && btnActive[index] === true ? 'btn-active' : 'btn-inActive'}
                                                    onClick={() => history.push(`/bookings/track/${item?.BL_Number}/${item?.containerNo}`)}
                                                >
                                                    Track
                                                </Button>
                                            </div>
                                        })
                                    }</>}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default TrackStatus;